import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "首頁", to: "/" },
  { label: "預製工法優勢", to: "/technology" },
  { label: "全省服務據點", to: "/locations" },
  { label: "自地自建說明講座", to: "/seminars" },
  { label: "作品介紹", to: "/portfolio" },
  { label: "集團品牌介紹", to: "/about" },
  { label: "服務流程與收費", to: "/process" },
  { label: "聯繫我們", to: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";
  const navBg = isHome && !scrolled
    ? "bg-transparent"
    : "bg-white/95 backdrop-blur-sm border-b border-warm-gray/50";
  const textColor = isHome && !scrolled ? "text-white" : "text-graphite";
  const ctaClass = isHome && !scrolled
    ? "bg-champagne text-graphite hover:bg-champagne/90"
    : "bg-graphite text-cream hover:bg-slate-blue";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${navBg}`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <nav className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 shrink-0">
            <img
              src="https://static.readdy.ai/image/c58d2dc5fdc4f4caa90264537c733184/c9f63e4dcd1d918f048871dce3e78869.png"
              alt="Chronos Space Logo"
              className="h-9 md:h-10 w-auto"
            />
            <span className={`font-serif font-bold text-base tracking-wide hidden sm:inline ${textColor}`}>
              Chronos Space
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-5">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-[0.9375rem] font-medium transition-colors duration-300 whitespace-nowrap ${
                  location.pathname === link.to
                    ? "text-champagne"
                    : `${textColor} hover:text-champagne`
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Desktop CTA */}
          <div className="hidden lg:block">
            <a
              href="https://lin.ee/OpssTIM"
              target="_blank"
              rel="noopener noreferrer"
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-[0.9375rem] font-semibold whitespace-nowrap transition-all duration-300 ${ctaClass}`}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-line-fill" />
              </span>
              加入 LINE 諮詢
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${textColor}`}
            aria-label="選單"
          >
            <i className={`text-2xl ${mobileOpen ? "ri-close-line" : "ri-menu-3-line"}`} />
          </button>
        </nav>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden bg-white border-t border-warm-gray/50 overflow-hidden transition-all duration-300 ${
          mobileOpen ? "max-h-[700px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-4 py-5 flex flex-col gap-2">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`py-3 px-4 rounded-lg text-lg font-medium transition-colors ${
                location.pathname === link.to
                  ? "text-champagne bg-champagne/5"
                  : "text-graphite hover:text-champagne hover:bg-champagne/5"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="https://lin.ee/OpssTIM"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 flex items-center justify-center gap-2 py-3 px-4 rounded-full bg-graphite text-cream font-semibold text-lg transition-all duration-300 hover:bg-slate-blue whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-line-fill" />
            </span>
            加入 LINE 諮詢
          </a>
        </div>
      </div>
    </header>
  );
}